module.exports = __webpack_public_path__ + "img/ico-facebook-messenger.72b77b8d.svg";